<!--
  - Copyright (c) 2019 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-card>
    <v-toolbar
      color="lime"
      dark
    >
      <v-toolbar-title>Chat</v-toolbar-title>
    </v-toolbar>
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
      >
        <v-list two-line>
          <template v-if="this.$store.state.chat.chatLoaded">
            <template v-for="(item, index) in messages">
              <v-list-item
                :key="item.message"
                avatar
              >
                <v-list-item-avatar>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <avatar
                          :fullname="item.nick"
                          :size="40"
                        />
                      </div>
                    </template>
                    <span v-text="item.nick" />
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text" />
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index < messages.length - 1"
                :key="`devider-${index}`"
                inset
              />
            </template>
          </template>
          <template v-else>
            <v-list-item>
              <v-list-item-content>
                <v-progress-linear :indeterminate="true" />
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider />
          <v-list-item>
            <v-list-item-avatar v-if="nick !== ''">
              <avatar
                :fullname="$store.state.chat.nick"
                :size="40"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-container fluid>
                <v-row>
                  <template v-if="nick === ''">
                    <v-col cols="5">
                      <v-text-field
                        v-model="newNick"
                        label="Nickname"
                        clearable
                        @change="nickChanged"
                      />
                    </v-col>
                    <v-col
                      cols="6"
                      offset="1"
                    >
                      <v-text-field
                        v-model="message"
                        label="Type here..."
                        clearable
                        readonly
                        append-outer-icon="send"
                        @click:append-outer="sendMessage"
                      />
                    </v-col>
                  </template>
                  <template>
                    <v-col
                      v-show="nick !== ''"
                      cols="12"
                    >
                      <v-text-field
                        ref="messageField"
                        v-model="message"
                        label="Type here..."
                        clearable
                        append-outer-icon="send"
                        @click:append-outer="sendMessage"
                        @change="sendMessage"
                      />
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Avatar from 'vue-avatar-component'
import dbg from "debug"
import Vue from "vue";

const debug = dbg('lnbig:pre-chat-component')

export default {
  name: "PreChat",
  components: {Avatar},
  data() {
    return {
      newNick: '',
      message: '',
      messageFieldFocus: false,
      serverError: null
    }
  },
  computed: {
    nick() {
      return this.$store.state.chat.nick
    },
    messages() {
      return this.$store.state.chat.messages
    }
  },
  mounted: async function () {
    try {
      this.$store.commit('chat/resetReCaptchaV2')
      this.$store.commit('chat/resetReCaptchaV3')
      await this.$store.state.helloPromise
    }
    catch (e) {
      debug("error: %s", e.message)
      this.showError(e.message)
    }
    this.$store.dispatch('chat/startChat', this)
  },
  methods: {
    showError(text) {
      this.$nextTick(
          () => {
            this.$snackBar.color = 'error'
            this.$snackBar.timeout = 5000
            this.$snackBar.text = text
            this.$snackBar.show = true
          }
      )
    },
    nickChanged(event) {
      this.$store.commit('chat/changeNick', event)
      console.log('nickChanged..., %o', event)
      this.$nextTick(() => {
        this.$refs.messageField.focus()
      })
    },
    sendMessage() {
      if (this.$store.state.chat.chatLoaded && this.message !== '') {
        console.log('Send message! %s', this.message)
        this.$store.dispatch('chat/sendMessage', this.message).catch((e) => {
          this.showError(e.message)
        })
        // this.messages.push({name: this.$store.state.chat.nick, message: this.message})
        // this.messages.splice(0, 1)
        this.message = ''
      }
      this.$nextTick(() => {
        this.$refs.messageField.focus()
      })
    }
  }
}
</script>

<style scoped>

</style>
